import React from 'react';
import { useStoreValue } from 'store';
import { getDataLayerElements } from 'utils/getDataLayerElements';
import { useEventTracking } from 'react-event-tracker';
import { Link, Text, Container, Flex, Stack, Grid } from 'basis';
import styled from '@emotion/styled';
import { NZV2FooterLogo } from 'components/logo/nz/NZV2Logo';
import { WidthContainer } from 'components/twenty-eight-degrees/Containers';

const FooterSources = {
  privacy_policy: {
    label: 'Privacy and Credit Reporting Policy',
    url: 'https://www.gemfinance.co.nz/privacy/',
  },
  terms_and_conditions: {
    label: 'Website Terms and Conditions',
    url: 'https://www.gemfinance.co.nz/terms-and-conditions/',
  },
  security: {
    label: 'Security',
    url: 'https://www.gemfinance.co.nz/scams-hub/',
  },
};

const getScreenSize = props =>
  props.theme?.screenSize || {
    sm: '576px',
    lg: '992px',
  };

export const FooterWrapper = styled.div`
  background-color: var(--Indigo-1000, #0b2374);

  ${props => `
    ${`@media (max-width: ${getScreenSize(props).sm})`} {
      & div > div > div > div > div {
        flex-wrap: wrap;
      }
    }

    ${`@media (min-width: ${getScreenSize(props).sm})`} {
      & div > div > div > div > div {
        flex-wrap: nowrap;
      }
    }
  `}

  ${props => `
    ${`@media (min-width: ${getScreenSize(props).lg})`} {
      & > div {
        display: flex;
      }
    }
  `}

  ${props => `
    ${`@media (max-width: ${getScreenSize(props).sm})`} {

        svg {
            height: 32px;
            width: 76px;
        }
    }
    `}
`;

export const LinkWrapper = styled.div`
  span {
    color: white;
    border-bottom-color: white;
    font-size: 14px;
  }

  span:hover {
    background: inherit;
    border-bottom-color: inherit;
    font-weight: 700;
  }
`;

export function NZV2Footer() {
  const [state] = useStoreValue();
  const { trackEvent, getQueryString } = useEventTracking();

  const trackEventSender = label => {
    trackEvent({
      event: {
        category: 'text-link',
        action: 'internal-link',
        location: 'footer',
        label,
      },
      ...getDataLayerElements(state),
    });
  };

  const getLinkWithAnalytics = key => {
    // TODO: update query params for AU Houndstooth products
    const gemid2 = getQueryString({
      event: {
        category: 'text-link',
        action: 'internal-link',
        location: 'footer',
        label: FooterSources[key].label,
      },
    });

    const link = new URL(FooterSources[key].url);
    // TODO: update query params for AU Houndstooth products
    link.searchParams.set('gemid2', gemid2);
    return link.href;
  };

  return (
    <Container testId="nzv2-card-footer">
      <FooterWrapper>
        <WidthContainer>
          <Container padding="5 0">
            <Container margin="auto" margin-md="auto">
              <Grid colsGutter="0" cols="6">
                <Grid.Item colSpan="0-1" colSpan-md="0" colSpan-lg="0" rowSpan="0" rowSpan-md="0" margin-md="0">
                  <Container padding="1 0 6 0" padding-md="0 0 5 0" padding-lg="1 0 6 0">
                    <Flex placeItems="center left">
                      <NZV2FooterLogo />
                    </Flex>
                  </Container>
                </Grid.Item>

                <Grid.Item colSpan="all">
                  <Flex placeItems="center left">
                    <Stack direction="horizontal" align="left" gap="3 4">
                      {Object.keys(FooterSources).map((key, index) => {
                        return (
                          <LinkWrapper key={index}>
                            <Link
                              variant="medium-bg"
                              href={getLinkWithAnalytics(key)}
                              newTab
                              onClick={() => trackEventSender(FooterSources[key].label)}
                            >
                              {FooterSources[key].label}
                            </Link>
                          </LinkWrapper>
                        );
                      })}
                    </Stack>
                  </Flex>
                </Grid.Item>

                <Grid.Item colSpan="all">
                  <Flex placeItems="center left">
                    <Container margin="7 0 0 0">
                      <Text textStyle="legal" color="white">
                        Gem Visa is provided by Latitude Financial Services Limited.
                      </Text>
                    </Container>
                  </Flex>
                </Grid.Item>
              </Grid>
            </Container>
          </Container>
        </WidthContainer>
      </FooterWrapper>
    </Container>
  );
}
